// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'calendar-empty';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M1.656 2.808h14.616c.648 0 1.152.504 1.152 1.152v12.384c0 .648-.504 1.152-1.152 1.152H1.656a1.137 1.137 0 0 1-1.152-1.152V3.96c.072-.648.576-1.152 1.152-1.152zM.576 7.344h16.848M5.04 4.464V.576m7.92 3.888V.576'
  />
);

export const viewBox = '0 0 18 18';
